import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import http from "../../utils/http";

const initialState = {
  isLoading: false,
  statistics: {},
};

export const getSidekickStatistics = createAsyncThunk(
  "application/getStatistics",
  async (payload, thunkAPI) => {
    try {
      const response = await http?.get(
        `${
          process.env.REACT_APP_API_SIDEKICK_BASE_URL
        }/get-sidekick-subscription-stats${
          payload?.startDate ? `?start=${payload?.startDate}` : ""
        }${payload?.endDate ? `&end=${payload?.endDate}` : ""}${
          payload?.date ? `?dateRange=${payload?.date}` : ""
        }`
      );
      return thunkAPI.fulfillWithValue(response.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const sidekickStatSlice = createSlice({
  name: "sidekick-stat",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSidekickStatistics.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSidekickStatistics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.statistics = action.payload;
      })
      .addCase(getSidekickStatistics.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default sidekickStatSlice.reducer;
